import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalConstants } from '@environments/global-Variables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'weaccess-request-approval-modal',
  templateUrl: './request-approval-modal.component.html',
  styleUrls: ['./request-approval-modal.component.scss']
})
export class RequestApprovalModalComponent {
  globalConstants = GlobalConstants;
  accessData!: any;
  type!: any;
  bsSystemAccessModalRef!: BsModalRef;
  requestApprovalForm!: FormGroup;
  @Output() requestApprovalEvent = new EventEmitter<string>();
  status: any;
  requestType: any;
  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private fb: FormBuilder) {
    this.accessData = this.modalService?.config?.initialState;
    this.type = this.accessData?.data?.type;
    this.status = this.accessData?.data?.status;
    this.requestType = this.accessData?.data?.requestType;
  }

  ngOnInit() {
    this.requestApprovalForm = this.fb.group({
      rejectReason: [, [Validators.required]],
      returnReason: [, [Validators.required]],
      revokeReason: [, [Validators.required]],
      suspendReason: [, [Validators.required]],
      resumeReason: [, [Validators.required]]
    });
  }

  /** Clear form values functionality */
  clearForm() {
    let clearFormValues = {
      rejectReason: null,
      returnReason: null,
      revokeReason: null,
      suspendReason: null,
      resumeReason: null
    }
    this.requestApprovalForm.patchValue(clearFormValues);
  }

  /** Modal close based on type of request functionality implementation */
  onClose(action: any) {
    if (action != 'close') {
      if (action === 'revokeAccess') {
        this.type = 'revoke';
      } else if (action === 'suspendAccess') {
        this.type = 'suspend';
      } else if (action === 'resumeAccess') {
        this.type = 'resume';
      } else if (action === 'cancel') {
        let requestData: any = {
          type: 'Cancel',
        }
        this.requestApprovalEvent.emit(requestData);
        this.bsModalRef.hide();
      } else if (action === 'confirm') {
        let requestData: any = {
          type: 'Confirm',
        }
        this.requestApprovalEvent.emit(requestData);
        this.bsModalRef.hide();
      } else if (action === 'confirmRequest') {
        let requestData: any = {
          type: 'ConfirmRequest',
        }
        this.requestApprovalEvent.emit(requestData);
        this.bsModalRef.hide();
      } else {
        let requestData: any = {
          type: this.type,
          formData: this.requestApprovalForm?.value
        }
        this.requestApprovalEvent.emit(requestData);
        this.bsModalRef.hide();
      }
    } else if (action === 'close') {
      this.bsModalRef.hide();
    }
  }

  /** Getting disabled status for update and submit button */
  getDisabledStatus(): any {
    if (this.type === 'reject') {
      if (this.requestApprovalForm?.value['rejectReason']) {
        return false;
      } else {
        return true;
      }
    } else if (this.type === 'return') {
      if (this.requestApprovalForm?.value['returnReason']) {
        return false;
      } else {
        return true;
      }
    } else if (this.type === 'revoke') {
      if (this.requestApprovalForm?.value['revokeReason']) {
        return false;
      } else {
        return true;
      }
    } else if (this.type === 'suspend') {
      if (this.requestApprovalForm?.value['suspendReason']) {
        return false;
      } else {
        return true;
      }
    } else if (this.type === 'resume') {
      if (this.requestApprovalForm?.value['resumeReason']) {
        return false;
      } else {
        return true;
      }
    }
  }
}
